// Real-world football formation presets with X/Y coordinates (0-100% of field).
// Y=0 is top (defense end zone), Y=100 is bottom (offense end zone).
// Line of scrimmage typically ~ y=70 for offense, y=30 for defense (mirrored).
//
// Each formation provides X/Y positions per slot key (QB, RB, WR1, etc.).
// The slot labels remain fixed; only their coordinates change.

// -------- TACKLE OFFENSE (11 slots: QB, RB, FB, WR1, WR2, TE, LT, LG, C, RG, RT) --------
const T_OL = { C: [50, 70], LG: [44, 70], RG: [56, 70], LT: [37, 70], RT: [63, 70] };

export const TACKLE_OFF_PRESETS = {
  "I-Form":      { ...T_OL, QB: [50, 73], TE: [70, 70], WR1: [10, 70], WR2: [90, 70], FB: [50, 79], RB: [50, 86] },
  "Strong I":    { ...T_OL, QB: [50, 73], TE: [70, 70], WR1: [10, 70], WR2: [90, 70], FB: [58, 79], RB: [50, 86] },
  "Weak I":      { ...T_OL, QB: [50, 73], TE: [70, 70], WR1: [10, 70], WR2: [90, 70], FB: [42, 79], RB: [50, 86] },
  "Double Wing": { ...T_OL, QB: [50, 73], TE: [30, 70], WR1: [70, 70], WR2: [78, 76], FB: [22, 76], RB: [50, 84] },
  "Goal Line":   { ...T_OL, LT: [33, 70], RT: [67, 70], QB: [50, 73], TE: [73, 70], WR1: [27, 70], WR2: [80, 70], FB: [50, 78], RB: [50, 84] },

  "Split Backs": { ...T_OL, QB: [50, 73], TE: [70, 70], WR1: [10, 70], WR2: [90, 70], FB: [40, 82], RB: [60, 82] },
  "Ace":         { ...T_OL, QB: [50, 73], TE: [70, 70], WR1: [10, 70], WR2: [90, 70], FB: [30, 70], RB: [50, 84] },
  "Wing-T":      { ...T_OL, QB: [50, 73], TE: [70, 70], WR1: [10, 70], WR2: [78, 74], FB: [42, 76], RB: [50, 84] },

  "Pistol":      { ...T_OL, QB: [50, 78], TE: [70, 70], WR1: [10, 70], WR2: [90, 70], FB: [38, 86], RB: [50, 86] },
  "Trips":       { ...T_OL, QB: [50, 78], TE: [70, 72], WR1: [80, 70], WR2: [88, 72], FB: [22, 70], RB: [50, 84] },
  "Empty":       { ...T_OL, QB: [50, 76], TE: [22, 70], WR1: [10, 70], WR2: [90, 70], FB: [78, 70], RB: [70, 72] },
  "Bunch":       { ...T_OL, QB: [50, 78], TE: [72, 70], WR1: [78, 72], WR2: [82, 74], FB: [16, 70], RB: [50, 84] },
};

// -------- TACKLE DEFENSE (11 slots: DE-L, DT-L, DT-R, DE-R, OLB-L, MLB, OLB-R, CB-L, CB-R, FS, SS) --------
export const TACKLE_DEF_PRESETS = {
  // Bases
  "4-3":         { "DE-L":[30,30], "DT-L":[42,30], "DT-R":[58,30], "DE-R":[70,30], "OLB-L":[28,22], "MLB":[50,22], "OLB-R":[72,22], "CB-L":[10,22], "CB-R":[90,22], "FS":[40,10], "SS":[60,10] },
  "3-4":         { "DE-L":[35,30], "DT-L":[50,30], "DT-R":[65,30], "DE-R":[78,24], "OLB-L":[22,24], "MLB":[42,22], "OLB-R":[58,22], "CB-L":[10,22], "CB-R":[90,22], "FS":[40,10], "SS":[60,10] },
  "5-2 (Oklahoma)": { "DE-L":[25,30], "DT-L":[38,30], "DT-R":[50,30], "DE-R":[62,30], "OLB-L":[75,30], "MLB":[42,22], "OLB-R":[58,22], "CB-L":[12,22], "CB-R":[88,22], "FS":[40,10], "SS":[60,10] },

  // Sub-packages (pass defense)
  "Nickel (4-2-5)": { "DE-L":[30,30], "DT-L":[42,30], "DT-R":[58,30], "DE-R":[70,30], "OLB-L":[40,22], "MLB":[60,22], "OLB-R":[50,15], "CB-L":[10,22], "CB-R":[90,22], "FS":[35,10], "SS":[65,10] },
  "Dime (4-1-6)":   { "DE-L":[30,30], "DT-L":[42,30], "DT-R":[58,30], "DE-R":[70,30], "OLB-L":[50,22], "MLB":[35,16], "OLB-R":[65,16], "CB-L":[8,20],  "CB-R":[92,20], "FS":[30,8],  "SS":[70,8] },
  "Prevent (3 deep)": { "DE-L":[35,30], "DT-L":[50,30], "DT-R":[65,30], "DE-R":[78,30], "OLB-L":[30,20], "MLB":[50,20], "OLB-R":[70,20], "CB-L":[20,8],  "CB-R":[80,8],  "FS":[50,4],  "SS":[35,16] },

  // Short Yardage
  "6-2 (Goal Line)": { "DE-L":[20,30], "DT-L":[35,30], "DT-R":[42,30], "DE-R":[58,30], "OLB-L":[65,30], "MLB":[42,24], "OLB-R":[58,24], "CB-L":[15,26], "CB-R":[85,26], "FS":[80,30], "SS":[50,18] },
  "4-4 Stack":      { "DE-L":[30,30], "DT-L":[42,30], "DT-R":[58,30], "DE-R":[70,30], "OLB-L":[30,22], "MLB":[42,22], "OLB-R":[58,22], "CB-L":[15,22], "CB-R":[85,22], "FS":[40,10], "SS":[70,22] },
};

// -------- FLAG OFFENSE (5 slots: QB, C, WR-L, WR-R, RB) --------
export const FLAG_OFF_PRESETS = {
  "Diamond":     { "QB":[50,76], "C":[50,70], "WR-L":[20,72], "WR-R":[80,72], "RB":[50,84] },
  "Stack":       { "QB":[50,76], "C":[50,70], "WR-L":[20,68], "WR-R":[20,76], "RB":[50,84] },
  "Spread 2x2":  { "QB":[50,76], "C":[50,70], "WR-L":[15,70], "WR-R":[85,70], "RB":[30,80] },
};

// -------- FLAG DEFENSE (5 slots: Rusher, LB-L, LB-R, CB-L, CB-R) --------
export const FLAG_DEF_PRESETS = {
  "2-1-2 (Caja)":      { "Rusher":[50,30], "LB-L":[35,22], "LB-R":[65,22], "CB-L":[20,12], "CB-R":[80,12] },
  "1-1-3 (Deep Cov)":  { "Rusher":[50,32], "LB-L":[50,22], "LB-R":[80,10], "CB-L":[20,10], "CB-R":[50,6] },
};

// Grouped UI structure
export const PRESET_GROUPS = {
  "tackle__offense": [
    { group: "Power / Heavy", items: ["I-Form", "Strong I", "Weak I", "Double Wing", "Goal Line"] },
    { group: "Pro Style",      items: ["Split Backs", "Ace", "Wing-T"] },
    { group: "Modern Spread",  items: ["Pistol", "Trips", "Empty", "Bunch"] },
  ],
  "tackle__defense": [
    { group: "Bases",          items: ["4-3", "3-4", "5-2 (Oklahoma)"] },
    { group: "Sub-Packages",   items: ["Nickel (4-2-5)", "Dime (4-1-6)", "Prevent (3 deep)"] },
    { group: "Short Yardage",  items: ["6-2 (Goal Line)", "4-4 Stack"] },
  ],
  "flag_masculino__offense": [
    { group: "Ofensivas Flag", items: ["Diamond", "Stack", "Spread 2x2"] },
  ],
  "flag_masculino__defense": [
    { group: "Defensivas Flag", items: ["2-1-2 (Caja)", "1-1-3 (Deep Cov)"] },
  ],
  "flag_femenino__offense": [
    { group: "Ofensivas Flag", items: ["Diamond", "Stack", "Spread 2x2"] },
  ],
  "flag_femenino__defense": [
    { group: "Defensivas Flag", items: ["2-1-2 (Caja)", "1-1-3 (Deep Cov)"] },
  ],
};

export const getPresetCoords = (category, unit, name) => {
  if (category === "tackle" && unit === "offense") return TACKLE_OFF_PRESETS[name];
  if (category === "tackle" && unit === "defense") return TACKLE_DEF_PRESETS[name];
  if (unit === "offense") return FLAG_OFF_PRESETS[name];
  if (unit === "defense") return FLAG_DEF_PRESETS[name];
  return null;
};

export const getPresetGroups = (category, unit) => {
  return PRESET_GROUPS[`${category}__${unit}`] || [];
};
